import { RewardDto, RewardPointsDto } from '@shared/dto';
import { RewardCodeType } from '@shared/models';

export class Reward {
  rewardBankId: number;
  categoryName: string;
  rewardId: number;
  expirationDate?: string; // Only available for rewards that have been purchased
  bannerLink: string;
  label: string;
  sublabel: string;
  priceToUnlock: number;
  additionalDetails?: string;
  termsAndConditions?: string;
  categoryDisplayOrder: number | null;
  activationsLeft: number; // Number of activations left for the reward
  codeDetails?: { type: RewardCodeType; value: string }; // Only for purchased rewards

  constructor(obj?: RewardDto) {
    if (obj) {
      this.label = obj.label;
      this.sublabel = obj.sublabel;
      this.rewardId = +obj.reward_id;
      this.bannerLink = obj.banner_link;
      this.codeDetails = obj.code_details;
      this.categoryName = obj.category_name;
      this.rewardBankId = +obj.reward_bank_id;
      this.expirationDate = obj.expiration_date;
      this.activationsLeft = obj.activations_left;
      this.additionalDetails = obj.additional_details;
      this.termsAndConditions = obj.terms_and_conditions;
      this.priceToUnlock = parseInt(obj.price_to_unlock, 10);
      this.categoryDisplayOrder = obj.category_display_order;
    }
  }

  get isActive(): boolean {
    return !!this.expirationDate && !!this.codeDetails;
  }
}

export class RewardPoints {
  accountId: number;
  rewardBankId: number;
  balance: {
    points: number;
    validUntil: string | null;
  }[];

  constructor(obj?: RewardPointsDto) {
    if (obj) {
      this.accountId = +obj.account_id;
      this.rewardBankId = +obj.reward_bank_id;
      this.balance = obj.balance.map((b) => ({
        points: +b.points,
        validUntil: b.valid_until,
      }));
    }
  }
}
